import {
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Tooltip,
  Typography,
  Checkbox,
  IconButton
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import Chip from '@mui/material/Chip';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { useEffect, useState } from "react";
import { cpfMask } from "utils/cpf";
import { ICampanhaRetificacoes } from "../types";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { Padding } from "@mui/icons-material";

dayjs.extend(utc)

interface IFilters {
    nomeCpf: string,
    parentesco: 'Todos' | 'Titular' | 'Dependente',
    erros: 'Todos' | 'Retificações' | 'Beneficiários' | 'Documentos',
    camposVazios?: 'Todos' | 'Field1' | 'Field2',
}

function formatDate(dateToFormat: string) {
  try {
    if (!dayjs(dateToFormat).isValid()) throw new Error();
    
    return dayjs(dateToFormat).utc().format(`DD/MM/YYYY`);
  } catch (error) {
    return `-`
  }
}

export function RetificacoesTable({ data: xxAllDataB, active = false }: { data: ICampanhaRetificacoes['result'], active?: boolean }) {
  const [xxAllDataz, setXxAllData] = useState<ICampanhaRetificacoes['result']>(xxAllDataB);

  const xxAllFilters: IFilters = {
      nomeCpf: '',
      parentesco: 'Todos',
      erros: 'Todos',
      camposVazios: 'Todos',
    }
    const [xxCurrentData, setXxCurrentData] = useState<ICampanhaRetificacoes['result']>(xxAllDataz);
    const [xxCurrentFilters, setXxCurrentFilters] = useState(xxAllFilters);

    useEffect(() => {
      setXxAllData([...xxAllDataB]);
      setXxCurrentData([...xxAllDataB]);
    }, [xxAllDataB])
  
    const [order, setOrder] = useState<'asc' | 'desc'>('asc');
    const [orderBy, setOrderBy] = useState<string>('nome');
  
    const parentescoOptions = ['Todos', ...new Set(xxAllDataz.map(item => item.parentesco))];
    const errosOptions = ['Todos', ...new Set(xxAllDataz.map(item => item.erros))];
    const camposVaziosOptions = ['Todos', ...new Set(xxAllDataz.map(item => item.camposVazios))];
  
    function handleFilters(filters: IFilters) {
      setXxCurrentFilters({ ...filters });
    }
  
    const handleSort = (property: string) => {
      const isAsc = order === 'asc'; 
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  
    useEffect(() => {
      const filteredData = xxAllDataz.filter(data => {
        const shouldDisplayName = data.nome.toLocaleLowerCase().includes(xxCurrentFilters.nomeCpf.toLocaleLowerCase()) || data.cpf.includes(xxCurrentFilters.nomeCpf);
        const shouldDisplayParentesco = xxCurrentFilters.parentesco === 'Todos' || xxCurrentFilters.parentesco === data.parentesco;
        const shouldDisplayTipoCampanhas =
          xxCurrentFilters.erros === 'Todos' ||
          data.erros.includes(xxCurrentFilters.erros);
        const shouldDisplayStatus = xxCurrentFilters.camposVazios === 'Todos' || xxCurrentFilters.camposVazios === data.camposVazios;
  
        return shouldDisplayName && shouldDisplayParentesco && shouldDisplayTipoCampanhas && shouldDisplayStatus;
      });
      const sortedData = filteredData.sort((a, b) => {
        if (orderBy === 'nome') {
          const aValue = a.nome.toLowerCase();
          const bValue = b.nome.toLowerCase();
          if (aValue < bValue) return order === 'asc' ? -1 : 1;
          if (aValue > bValue) return order === 'asc' ? 1 : -1;
          return 0;
        }
        
        if (a.parentesco < b.parentesco) return order === 'asc' ? -1 : 1;
        if (a.parentesco > b.parentesco) return order === 'asc' ? 1 : -1;
        return 0;
      });
      setXxCurrentData([ ...sortedData ]);
    }, [xxCurrentFilters, order, orderBy]);
  
    return (
      <>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <TextField
            fullWidth
            label='Nome beneficiário ou CPF'
            placeholder='Digite para pesquisar'
            variant='outlined'
            value={xxCurrentFilters.nomeCpf}
            onChange={(e) => handleFilters({ ...xxCurrentFilters, nomeCpf: e.target.value  })}
            InputProps={{ 
              startAdornment: (
                <InputAdornment position='start'>
                  <SearchIcon color='action' style={{ width: '24px', aspectRatio: '1' }}/>
                </InputAdornment>
              )
            }}
          />
          <div style={{ width: '100%', display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center', marginBottom: '24px' }}>
            <Typography color='gray' variant='body2'>Filtrar por</Typography>
            <FormControl style={{ width: '165px' }}>
              <InputLabel id="parentesco">Plano</InputLabel>
              <Select
                labelId="parentesco"
                label="Parentesco"
                value={xxCurrentFilters.parentesco}
                defaultValue={'Todos'}
                //@ts-ignore
                onChange={(e) => handleFilters({ ...xxCurrentFilters, parentesco: e.target.value  })}
                style={{ height: '40px' }}
              >
                {parentescoOptions.map(option => (
                  <MenuItem value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl style={{ width: '165px' }}>
              <InputLabel id="erros">Tipo</InputLabel>
              <Select
                labelId="erros"
                label="Tipo de campanhas"
                value={xxCurrentFilters.erros}
                defaultValue={'Todos'}
                //@ts-ignore
                onChange={(e) => handleFilters({ ...xxCurrentFilters, erros: e.target.value  })}
                style={{ height: '40px' }}
              >
                {errosOptions.map(option => (
                  <MenuItem value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl style={{ width: '165px' }}>
              <InputLabel id="camposVazios">Situação</InputLabel>
              <Select
                labelId="camposVazios"
                label="Status"
                value={xxCurrentFilters.camposVazios}
                defaultValue={'Todos'}
                //@ts-ignore
                onChange={(e) => handleFilters({ ...xxCurrentFilters, camposVazios: e.target.value  })}
                style={{ height: '40px' }}
              >
                {camposVaziosOptions.map(option => (
                  <MenuItem value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button onClick={() => handleFilters({ nomeCpf: '', erros: 'Todos', camposVazios: 'Todos', parentesco: 'Todos' })}>Limpar filtro</Button>
          </div>
        </div>
        {active ? (
          <TableContainer
            sx={{
              "& .MuiTableCell-root": {
                background: "#FFFFFF !important",
              },
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>                  
                  <TableCell>
                    <TableSortLabel
                        active={orderBy === 'nome'}
                        direction={orderBy === 'nome' ? order : 'asc'}
                        onClick={() => handleSort('nome')}
                      >
                      Nome Beneficiário
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                        active={orderBy === 'cpf'}
                        direction={orderBy === 'cpf' ? order : 'asc'}
                        onClick={() => handleSort('cpf')}
                      >
                      CPF/CNPJ
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                        active={orderBy === 'parentesco'}
                        direction={orderBy === 'parentesco' ? order : 'asc'}
                        onClick={() => handleSort('parentesco')}
                      >
                      Parentesco
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                        active={orderBy === 'cargo'}
                        direction={orderBy === 'cargo' ? order : 'asc'}
                        onClick={() => handleSort('cargo')}
                      >
                      Cargo
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                        active={orderBy === 'dataNascimento'}
                        direction={orderBy === 'dataNascimento' ? order : 'asc'}
                        onClick={() => handleSort('dataNascimento')}
                      >
                      Data de nascimento
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                        active={orderBy === 'sexo'}
                        direction={orderBy === 'sexo' ? order : 'asc'}
                        onClick={() => handleSort('sexo')}
                      >
                      Sexo
                    </TableSortLabel>
                  </TableCell>                                  
                </TableRow>
              </TableHead>
              <TableBody>
                {xxCurrentData.map((row) => (
                  <TableRow key={row.nome}>                    
                    <TableCell>
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {row.nome}
                      </div>
                    </TableCell>                 
                    <TableCell>
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {Number(row.cpf) ? cpfMask(row.cpf) : row.cpf}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {row.parentesco}
                      </div>
                    </TableCell>                  
                    <TableCell>
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {row.cargo || ""}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {!row?.dataNascimento ? "-" : formatDate(row.dataNascimento)}
                      </div>  
                    </TableCell>
                    <TableCell>
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {row.sexo }
                      </div>  
                    </TableCell>                    
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '24px', padding: '0 0 24px 0' }}>
              
            </div>
            <Typography style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600}}>Nenhum arquivo foi carregado até o momento.</Typography>
            <Typography variant="body2" color="textSecondary">No botão “Atualizar fonte de dados” faça o carregamento do arquivo necessario.</Typography>
          </div>
          </>
        )}
      </>
    );
}
